import React, { FC } from 'react'
import { Markdown } from './Markdown'

interface IDocumentProps {
  markdown: string
}

export const InboundParserDocument: FC<IDocumentProps> = ({ markdown }) => {
  return (
    <div>
      <Markdown>{markdown}</Markdown>
    </div>
  )
}
